module.exports = __webpack_public_path__ + "img/home.72551c0d.svg";